import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <footer class="page-footer font-small blue">
                <div class="footer-copyright text-center py-3">Developed by João Álvaro Ferreira
                </div>
            </footer>
            );
        }
}

export default Footer;